import type {
  CustomerCompanySearchResponse,
  CustomerInformationRequest,
  CustomerInformationResponse,
  CustomerCasesRequest,
  CustomerCasesResponse,
} from '@/types/customer';
import { API_ENDPOINTS } from '@/constants';

import type { ApiBuilder } from './types';

export const customerApi = (builder: ApiBuilder) => ({
  searchCustomersByCompanyName: builder.query<
    CustomerCompanySearchResponse,
    { companyName: string }
  >({
    query: ({ companyName }) => ({
      url: `${API_ENDPOINTS.CUSTOMER.BASE_URL}${API_ENDPOINTS.CUSTOMER.SEARCH}`,
      method: 'GET',
      params: { companyName },
    }),
  }),

  getCustomerInformation: builder.query<
    CustomerInformationResponse,
    CustomerInformationRequest
  >({
    query: ({ workSpaceID }) => {
      const params = new URLSearchParams({ workSpaceID });
      return {
        url: `${API_ENDPOINTS.CUSTOMER.BASE_URL}${API_ENDPOINTS.CUSTOMER.INFORMATION}?${params.toString()}`,
        method: 'GET',
      };
    },
    providesTags: ['Customer'],
  }),

  getCustomerCases: builder.query<CustomerCasesResponse, CustomerCasesRequest>({
    query: ({ workSpaceID, page, pageSize }) => {
      const params = new URLSearchParams({ workSpaceID });
      if (page !== undefined) params.append('page', String(page));
      if (pageSize !== undefined) params.append('pageSize', String(pageSize));

      return {
        url: `${API_ENDPOINTS.CUSTOMER.BASE_URL}${API_ENDPOINTS.CUSTOMER.CASES}?${params.toString()}`,
        method: 'GET',
      };
    },
    providesTags: ['Customer'],
  }),
});
